import React from 'react';
import { Container } from './styles';

const SplitInputs = ({ children }) => <Container>{children}</Container>;

export default SplitInputs;
